import { Form, Input } from 'antd';
import { BankAccountsGroup } from '@/components/bank-accounts-group';
import { cn } from '@/libs/utils';
import { useCompanyGeneralDataForm } from '../CompanyGeneralDataFormContext';

/** Address, contact and bank account fields. */
export default function CompanyContactFields() {
  const {
    addressKeys,
    addressState,
    bankAccountKeys,
    bankAccountState,
    cityKeys,
    cityState,
    emailKeys,
    emailState,
    form,
    phoneNumberKeys,
    phoneNumberState,
    sectionClass,
    t,
    zipKeys,
    zipState,
  } = useCompanyGeneralDataForm();

  return (
    <div
      className={cn(
        'mb-5 rounded-md border bg-zinc-50 px-4 pt-5',
        sectionClass('kontakt')
      )}
    >
      {addressState?.visible && (
        <Form.Item name={addressKeys} label={t('address', { ns: 'forms' })}>
          <Input
            placeholder={t('address', { ns: 'forms' })}
            disabled={addressState?.disabled}
          />
        </Form.Item>
      )}

      <div className="grid grid-cols-2 gap-x-5">
        {zipState?.visible && (
          <Form.Item name={zipKeys} label={t('postalNumber', { ns: 'forms' })}>
            <Input
              placeholder={t('postalNumber', { ns: 'forms' })}
              disabled={zipState?.disabled}
            />
          </Form.Item>
        )}

        {cityState?.visible && (
          <Form.Item name={cityKeys} label={t('city', { ns: 'forms' })}>
            <Input
              placeholder={t('city', { ns: 'forms' })}
              disabled={cityState?.disabled}
            />
          </Form.Item>
        )}

        {emailState?.visible && (
          <Form.Item name={emailKeys} label={t('email', { ns: 'forms' })}>
            <Input
              placeholder={t('email', { ns: 'forms' })}
              disabled={emailState?.disabled}
            />
          </Form.Item>
        )}

        {phoneNumberState?.visible && (
          <Form.Item
            name={phoneNumberKeys}
            label={t('phoneNumber', { ns: 'forms' })}
          >
            <Input
              type="tel"
              placeholder={t('phoneNumber', { ns: 'forms' })}
              disabled={phoneNumberState?.disabled}
            />
          </Form.Item>
        )}
      </div>

      {bankAccountState?.visible && (
        <Form.Item
          label={t('bankAccountNumber', { ns: 'forms' })}
          name={bankAccountKeys}
        >
          <BankAccountsGroup
            form={form}
            name={bankAccountKeys[1]}
            nestedName={bankAccountKeys[0]}
            disabled={bankAccountState?.disabled}
          />
        </Form.Item>
      )}
    </div>
  );
}
